import { createContext, useReducer } from 'react';
import { SnackbarProvider } from 'notistack';

// ACTIONS
const ADD = 'ADD_NOTIFY';
const REMOVE = 'REMOVE_NOTIFY';
const CLEAR = 'CLEAR_NOTIFY';
const REPLACE = 'REPLACE_NOTIFY';

export const Clear = () => ({ type: CLEAR })
export const Remove = (index) => ({ type: REMOVE, index })
export const Add = (notification) => ({ type: ADD, notification })
export const Replace = (notifications) => ({ type: REPLACE, notifications })

// CONTEXT
export const NotificationContext = createContext();

// PROVIDER
const NotificationProvider = ({ children, ...rest }) => {
    const reducer = (state, action) => {
        switch (action.type) {
            case CLEAR:
                return { notifications: [] }
            case REPLACE :
                return { notifications: action.notifications }
            case ADD:
                return { notifications: [...state.notifications, action.notification] }
            case REMOVE:
                return {
                    notifications: state.notifications
                        .filter((_, index) => index === action.index)
                }
            default:
                return state
        }
    }

    return (
        <SnackbarProvider maxSnack={3} {...rest}>
            <NotificationContext.Provider value={useReducer(reducer, { notifications: [] })}>
                {children}
            </NotificationContext.Provider>
        </SnackbarProvider>
    )
}

export default NotificationProvider;
